import React, { useContext, useState } from 'react';
import { observer } from 'mobx-react';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Col } from 'uiKit/atoms/Col/Col';
import { useStores } from 'stores';
import styles from './LotsList.module.scss';
import { AuthContext } from 'context/AuthContext';
import CharityBannerLots from 'pages/MyLots/MyCharityLots';
import LotCard from '../LotCard/LotCard';

const LotsList = () => {
  const { isAuthenticated } = useContext(AuthContext);
  const {
    lotStore: { lotData },
  } = useStores();
  const [isBannerVisible, setBannerVisible] = useState(true);

  const location = useLocation();

  const shouldRenderCharityBanner = location.pathname !== '/mylots' && location.pathname !== '/mySubscriptions';

  const handleCloseBanner = () => {
    setBannerVisible(false);
  };

  if (!isAuthenticated) {
    toast.error('Please, log in');
    return;
  }


  return (
    <div className={styles.bns3_lots_list_container}>
      {lotData.map((lot, index) => (
        <React.Fragment key={lot.id}>
          <LotCard lot={lot} />

          {index === 2 && isBannerVisible && shouldRenderCharityBanner && (
            <Col span={24} className={styles.charity_banner_container}>
              <CharityBannerLots onClose={handleCloseBanner} />
            </Col>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default observer(LotsList);
